import { lighten } from '@material-ui/core/styles/colorManipulator';
export const styles = theme => ({
    root:{
      marginTop: theme.spacing(3),
      padding: theme.spacing(4),
      color: '#292f48',
      flexGrow: 1,
    //   width: theme.spacing(105),
    //   height: theme.spacing(105),
    },
    nameMonth: {
        textTransform: 'capitalize'
    },
    frameTitle: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    button: {
        // paddingLeft: '32px',
        // paddingRight: '32px',
        // paddingTop: '12px',
        // paddingBottom: '12px',
        textAlign: 'center',
        fontSize: '0.785rem',
        marginBottom: theme.spacing(1),
        '&:last-child' : {
            marginBottom: 0
        }
    },
    btnBlue:{
        backgroundColor: '#292f48',
    },
    btnRed:{
        backgroundColor: '#ff6b5c',
    },
    wrapButton: {
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'column',
    },
    selectModal:{
        fontSize: '0.889rem'
    },
    label:{
        color: '#292f48',
        fontSize: '1rem',
        fontWeight: 'bold'
    },
    // General
    fs12: {
        fontSize: '12px',
    },
    fs1: {
        fontSize: '1rem',
    },
    textLeft: {
        textAlign: 'left',
    },
    textRight: {
        textAlign: 'right',
    },
    textCenter: {
        textAlign: 'center',
    },
    textBold:{
        fontWeight: 'bold',
        fontFamily: "Roboto",
    },
    p0:{
        padding: 0
    },
    pl2:{
        paddingLeft: theme.spacing(2),
    },
    pr2:{
        paddingRight: theme.spacing(2),
    },
    mt2:{
        marginTop: theme.spacing(2),
    },
    mt3:{
        marginTop: theme.spacing(3),
    },
    mt4:{
        marginTop: theme.spacing(4),
    },
    backgroundPrimary:{
        backgroundColor: 'rgba(255, 81, 63, 0.1)',
    },
    backgroundGray:{
        backgroundColor: 'rgba(41, 47, 72, 0.1)',
    },
})